import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  IMG_INVASIVEHEALTH_THEREISNOHURRY,
  IMG_INVASIVEHEALTH_TIMETOTHINK,
  IMG_INVASIVEHEALTH_NOTSURE,
  IMG_INVASIVEHEALTH_SAFEHANDS,
} from '../../../config/constants/images';
import {
  IHEALTH_TITLE,
  IHEALTH_TITLE_NOHURRY,
  IHEALTH_TEXT_NOHURRY,
  IHEALTH_TITLE_TIMETOTHINK,
  IHEALTH_TEXT_TIMETOTHINK,
  IHEALTH_TITLE_NOTSURE,
  IHEALTH_TEXT_NOTSURE,
  IHEALTH_TITLE_SAFEHANDS,
  IHEALTH_TEXT_SAFEHANDS,
} from '../../../config/text/text';
import ThemeContext from '../../../providers/ThemeProvider';
import InvasiveHealthRow from './InvasiveHealthRow';

const InvasiveHealth = ({ deal, desktop, mobile }) => {
  const theme = useContext(ThemeContext);
  if (!deal || !deal.invasiveHealth) return null;

  return (
    <>
      <div
        className={`ihealth-wrapper ${desktop && 'desktop'} ${
          mobile && 'mobile'
        }`}
      >
        <div className="ihealth-container">
          <div className="ihealth-header">{IHEALTH_TITLE}</div>
          <div className="ihealth-body">
            <InvasiveHealthRow
              border
              image={
                IMG_INVASIVEHEALTH_THEREISNOHURRY[process.env.NEXT_PUBLIC_BRAND]
              }
              imagealt={IHEALTH_TITLE_NOHURRY}
              text={IHEALTH_TEXT_NOHURRY}
              title={IHEALTH_TITLE_NOHURRY}
            />
            <InvasiveHealthRow
              border
              image={
                IMG_INVASIVEHEALTH_TIMETOTHINK[process.env.NEXT_PUBLIC_BRAND]
              }
              imagealt={IHEALTH_TITLE_TIMETOTHINK}
              text={IHEALTH_TEXT_TIMETOTHINK}
              title={IHEALTH_TITLE_TIMETOTHINK}
            />
            <InvasiveHealthRow
              border
              image={IMG_INVASIVEHEALTH_NOTSURE[process.env.NEXT_PUBLIC_BRAND]}
              imagealt={IHEALTH_TITLE_NOTSURE}
              text={IHEALTH_TEXT_NOTSURE}
              title={IHEALTH_TITLE_NOTSURE}
            />
            <InvasiveHealthRow
              border={false}
              image={
                IMG_INVASIVEHEALTH_SAFEHANDS[process.env.NEXT_PUBLIC_BRAND]
              }
              imagealt={IHEALTH_TITLE_SAFEHANDS}
              text={IHEALTH_TEXT_SAFEHANDS}
              title={IHEALTH_TITLE_SAFEHANDS}
            />
          </div>
        </div>
      </div>
      <style jsx>{`
        .ihealth-wrapper {
          display: block;
          width: 100%;
          border-radius: 3px;
          overflow: hidden;
          margin-bottom: 13px;
        }

        @media (max-width: ${theme.breakpoints.xlUp}) {
          .ihealth-wrapper.desktop {
            display: none;
          }
        }
        @media (min-width: ${theme.breakpoints.xlUp}) {
          .ihealth-wrapper.mobile {
            display: none;
          }
        }

        .ihealth-container {
          width: 100%;
          height: 100%;
          border: 3px solid ${theme.colors.primary};
        }
        .ihealth-header {
          margin: 0 auto;
          color: white;
          background-color: ${theme.colors.primary};
          font-size: 18px;
          padding-top: 35px;
          padding-bottom: 35px;
          text-align: center;
        }
        .ihealth-row {
          display: flex;
          margin: 10px;
          padding-top: 20px;
          padding-bottom: 20px;
        }
        .ihealth-row.border {
          border-bottom: 1px solid ${theme.colors.primary};
        }
        .ihealth-logo img {
          max-width: 76px;
          width: auto;
        }
        .ihealth-text {
          padding-left: 10px;
        }
        .ihealth-text .title {
          font-size: 14px;
          font-weight: bold;
          color: ${theme.colors.ihealthtext};
        }
        .ihealth-text .text {
          font-size: 14px;
          color: ${theme.colors.ihealthtext};
        }
      `}</style>
    </>
  );
};

InvasiveHealth.propTypes = {
  deal: PropTypes.object,
  desktop: PropTypes.bool,
  mobile: PropTypes.bool,
};

InvasiveHealth.defaultProps = {
  deal: null,
  desktop: false,
  mobile: false,
};

export default InvasiveHealth;
